import './DynamicSpeaker.css'
import {useEffect, useState} from "react";
import columnCssGenerator from '../lib/columnCssGenerator';
import rowCssGenerator from '../lib/rowCssGenerator';
import unique from '../lib/unique';
import Event from "./Event.component";
import Rooms from "./Rooms.component";


// Generate grid container css then return it
const container = (roomAmount, times, startTimes, endTimes) => {
    return {
        gridTemplateRows: rowCssGenerator(unique(times), startTimes, endTimes),
        gridTemplateColumns: columnCssGenerator(roomAmount)
    }
}

const DynamicSpeaker = ({mainCategory, eventDate, eventMenuLink}) => {

    const [rooms, setRooms] = useState([]);
    const [events, setEvents] = useState([]);
    const [startTimes, setStartTimes] = useState([]);
    const [endTimes, setEndTimes] = useState([]);


    // Au démarrage de la page (composant DynamicSpeaker)
    useEffect(() => {
        fetch('/api/getEvents.php?mainCategory=' + mainCategory)
            .then((res) => {
                if (res.json) {
                    res.json().then((json) => {
                        json.events.sort((a, b) => (a.rooms.startRoom > b.rooms.startRoom) ? 1 : ((b.rooms.startRoom > a.rooms.startRoom) ? -1 : 0));
                        json.events.sort((a, b) => (a.dtstarttime > b.dtstarttime) ? 1 : ((b.dtstarttime > a.dtstarttime) ? -1 : 0));
                        setEvents(json.events);
                        const startTimes = [];
                        const endTimes = [];
                        json.events.forEach(event => {
                            const start = (event.dtstarttime?.length === 4 ? '0' : '') + event.dtstarttime?.replace(':', '')
                            startTimes.push(start);
                            const end = (event.dtendtime?.length === 4 ? '0' : '') + event.dtendtime?.replace(':', '')
                            endTimes.push(end);
                        })
                        setStartTimes(startTimes);
                        setEndTimes(endTimes);
                        setRooms(json.rooms);
                    }).catch((jsonParseFail) => {
                        console.error(jsonParseFail)
                    })
                }
            }).catch((fail) => {
            console.error(fail)
        })
    }, [])

    var timeSlot = null;
    var prevTimeSlot = timeSlot;

    return (
        <div id="planning">
            {/* <div style={{textAlign: 'center', margin: '1em'}}>
                <a href="/images/pdf/fpu-2021_programme.pdf" target="_blank" className="btn btn-primary">Télécharger le
                    programme</a>
            </div> */}

            <div id="day1">
                <div className="text">
                    <h1>{eventDate}</h1>
                </div>
                <div className="schedule" style={container(rooms.length, startTimes.concat(endTimes), startTimes, endTimes)} aria-labelledby="schedule-heading">
                    <Rooms rooms={rooms}/>
                    {
                        events?.map((schedule, key) => {
                            if (prevTimeSlot !== schedule.dtstarttime) {
                                timeSlot = schedule.dtstarttime;
                                prevTimeSlot = timeSlot;
                            } else {
                                timeSlot = false;
                            }
                            return (
                                <Event key={key} event={schedule} timeSlot={timeSlot} rooms={rooms} eventMenuLink={eventMenuLink}/>
                            )
                        })
                    }
                </div>
            </div>
        </div>
    );
}

export default DynamicSpeaker;